import { ReactComponent as IconArrowLeft } from "@/assets/svgs/chevron-left-medium.svg";
import { ReactComponent as IconArrowRight } from "@/assets/svgs/chevron-right-medium.svg";
import { ReactComponent as IconStepperDotActive } from "@/assets/svgs/quicklink-stepper-dot-active.svg";
import { ReactComponent as IconStepperDot } from "@/assets/svgs/quicklink-stepper-dot.svg";
import { ReactComponent as IconStepper } from "@/assets/svgs/stepper-ellipsis.svg";
import { useState } from "react";
import MultiClamp from "react-multi-clamp";

const QuickLinkStepper = ({
	labelList,
	activeStep,
	setActiveStep,
	stepBy,
}) => {
	const [activeIndex, setActiveIndex] = useState(0);

	const updateActiveIndex = (newIndex) => {
		if (newIndex < 0) {
			newIndex = 0;
		}
		if (newIndex > labelList.length - 5) {
			newIndex = labelList.length - 5;
		}

		setActiveIndex(newIndex);
	};

	return (
		<div className="quicklink-stepper">
			<div className="quicklink-stepper__arrow">
				{labelList?.length > 5 && activeIndex !== 0 && (
					<div
						className="quicklink-stepper__arrow-icon"
						onClick={() => updateActiveIndex(activeIndex - stepBy)}
						data-testid="quicklink-left-arrow"
					>
						<IconArrowLeft />
					</div>
				)}
			</div>

			<div
				className={`${
					labelList?.length > 5 ? "quicklink-stepper-container" : ""
				}`}
			>
				<div
					className="quicklink-stepper__inner-wrapper"
					style={{
						transform: `translate(-${activeIndex * 196}px)`,
					}}
					data-testid="stepper-inner-wrapper"
				>
					{labelList?.map((item, index) => (
						<div className="quicklink__step-block" key={item.id}>
							<div className="quicklink__stepper-wrapper">
								<div className="quicklink__stepper-ellipsis">
									{index !== 0 && <IconStepper />}
								</div>
								{activeStep === item.id ? (
									<div className="quicklink__stepper-dot--active">
										<IconStepperDotActive />
									</div>
								) : (
									<div className="quicklink__stepper-dot">
										<IconStepperDot />
									</div>
								)}
								<div className="quicklink__stepper-ellipsis">
									{index !== labelList.length - 1 && (
										<IconStepper />
									)}
								</div>
							</div>
							<div className="quicklink__label-wrapper">
								<div
									className={`quicklink__labels ${
										item.status
											? "quicklink__labels--badge"
											: ""
									}`}
								>
									<div
										className={`quicklink__label-text ${
											activeStep === item.id
												? "quicklink__label-text--active"
												: "quicklink__label-text--non-active"
										}`}
										onClick={() => {
											setActiveStep(item.id);
										}}
										data-testid="label-text"
									>
										<MultiClamp clamp={2}>
											{item.name}
										</MultiClamp>
									</div>
									{item.status && (
										<div
											className={`veridapt-badge ${
												activeStep === item.id
													? "veridapt-badge--active"
													: "veridapt-badge--inactive"
											}`}
											style={{ marginTop: "auto" }}
											data-testid="badge-text"
										>
											{item.status}
										</div>
									)}
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
			<div className="quicklink-stepper__arrow">
				{labelList?.length > 5 && activeIndex !== labelList.length - 5 && (
					<div
						className="quicklink-stepper__arrow-icon"
						onClick={() => updateActiveIndex(activeIndex + stepBy)}
						data-testid="quicklink-right-arrow"
					>
						<IconArrowRight />
					</div>
				)}
			</div>
		</div>
	);
};

export default QuickLinkStepper;
